module.exports = __webpack_public_path__ + "static/media/close.5596914b.svg";